import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Music } from 'lucide-react';

export function MusicDetail() {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="container mx-auto px-4 py-8">
      <Link
        to="/music"
        className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Music Assets
      </Link>

      <div className="flex items-center gap-3 mb-6">
        <Music className="w-8 h-8 text-blue-600" />
        <h1 className="text-3xl font-bold">Music Asset {id}</h1>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Music asset details coming soon...</p>
      </div>
    </div>
  );
}
